import { Pipe, PipeTransform } from '@angular/core';
import { Sex } from '../model/patient.model';

@Pipe({
  name: 'patientSex'
})
export class PatientSexPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    const sex: Sex = value as Sex;
    if (sex === Sex.FEMALE) {
      return 'Femmina';
    }
    else if (sex === Sex.MALE) {
      return 'Maschio';
    }
    return 'Non specificato';
  }

}
